/*
---
name: Limousine Widget
description: Autocompleter
authors:
- Kien Vuong (http://www.reol.com)
license:
- MIT-style license
---
*/

/**

Limousine
=========
Limousine is an autocompleter.

Options
-------
+ _cls_ : The CSS class name for the widget
+ _textfield_selector_ : the selector to get the main text field - the main element to interact with in this widget.
+ _keyfield_selector_ : Sometimes a completer needs to coordinate with other field of the form (to update the selected item's ID). This use case is very common in webadmin.
+ _delay_ : time between making a key stoke and calling the rpc
+ _min_chars_ : the	minimum provided characters before making an rpc call
+ _max_results_ : control the maximum display results on the front end. Only apply for tpc that return a list of items (NOT rpc that returns HTML content)
+ _extra_data_ : (optional) extra data (besides data that is already on the form) to submit to the rpc
+ _cache_ : enable cache
+ _form_action_ : (optional) force form action if one wants to use different action than the action defined in the html markup of the form
+ _form_method_ : (optional) force form method if one wants to use different submit method than the action defined in the html markup of the form
+ _select_first_ : force select first result item?
+ _type_ahead_ : enable type ahead feature
+ _submit_onenter_ : submit the form if user presses the enter key
+ _data_source_callback_ : (optional) a function that return content of the rpc in string format - useful for local testing
+ _result_item_selector_ : if rpc returns HTML markup, we need a way to select all the relevant results items (because not all the elements in the results HTML are result items.)
+ _html_key_ : if rpc returns HTML markup in JSON format (i.e.: {'html': '<div class="results">this is the result</div>'}), we to specify the name of the json node that contains the HTML markup
+ _list_key_ : if rpc returns a lists of items in JSON format (i.e.: {'items': [ {'value': 'Result 1', 'key': '1'}, {'value': 'Result 2', 'key': '2'} ]}), we to specify the name of the json node that contains the array of items
+ _item_key_field_ : if rpc returns a lists of items in JSON format, we need the name of the field that contains the key value of the result item (i.e, : {'key': '12', 'value': 'Person name with id 12'})
+ _item_value_field_ : if rpc returns a lists of items in JSON format, we need the name of the field that contains the display value of the result item (i.e, : {'value': 'Search value 1'})
+ _item_url_field_ : (optional) if rpc returns a lists of items in JSON format, we need the name of the field that contains url of the result item (i.e, : {'url': '/listing_104'}) : so that user clicks on the result item; she/he will be redirected to that url
+ _create_list_callback_ : (optional) a function that return a list element (usually an <UL> or <OL> element)
+ _create_list_item_callback_ : (optional) a function that return a list item element (usually an <LI> element)
+ _highlight_markup_ : string of markup to highlight the display value of the result items.
+ __results_ : the element to inject the search result.
+ _over_text_ : a string to add overtext feature to the query text field.
+ _item_hover_cls_ : a string of which value is the class name to add to the item when mouseover


To do
-----
+ Add support for Slide animation

**/
var Limousine = new Class({
	Implements: [Options, Events],
	options: {
		cls: 'w_limousine',
		textfield_selector: 'input#query',
		keyfield_selector: 'input#id',
		delay: 300,
		min_chars: 3,
		max_results: 20,
		external_form: true,
		eval_scripts: true,
		extra_data: {rpc:1},
		cache: false,
		form_action: null,
		form_method: 'GET',
		select_first: false,
		type_ahead: true,
		submit_onenter: false,
		data_source_callback: null,	// for local testing withput rpc
		result_item_selector: '.items .item', // for html return
		html_key: 'html',	 // for json that contain html
		script_key: 'script',	 // for json that contain script
		list_key: 'items',	// for json list return
		item_key_field: 'key',	 // for json list return
		item_value_field: 'value', // for json list return
		item_url_field: 'url', // for json list return
		item_sel: 'li.item',
		create_list_callback: null,	// for create list element (when json list return)
		create_list_item_callback: null,	 // for create list item element (when json list return)
		highlight_markup: '<strong class="highlight">{query}</strong>',	 // for highlighting search term
		_results: null,
		over_text: 'search…',
		item_hover_cls: 'hover',
		no_query: false //when you don't need query set to true
	},
	/**
	initialize
	----------
	Checks for the existence of required elements

	###Arguments
	+ _element_: The element which will be scrolled
	+ _options_: Pass in a hash of options for the class

	**/
	initialize: function(element, options) {
		this.setOptions(options);
		this._element = element;
		if(this._element != null) {
			this.config();

			this.build();
		}
	},

	config: function(){
		var _self = this._element,
				opts = this.options,
				cls = opts.cls,
				fcls = '.'+cls,
				_config = _self.getElement(fcls+'_config');

		if(_config){
			Object.each(opts, function(val,key){
													opts[key] = _config.get('data-'+key.replace('_', '-')) || val;
													if(opts[key]){
														if(opts[key].toString() == 'true'){
															opts[key] = true;
														}else if(opts[key].toString() == 'false'){
															opts[key] = false;
														}
													}
												});
		}
	},

	/**
	build
	----------
	Setup the widget.
	Attach events to widget
	###Arguments
	+ _void_

	###Return
	+ _this widget_

	**/
	build: function(){
		var opts = this.options,
				_self = this._element;
		this._field = _self.getElement(opts.textfield_selector);

		if(this._field){
			this._field.set('autocomplete', 'off').addClass(opts.cls + '_autocomplete');

			this._form = this._field.getParent('form');

			if(opts.keyfield_selector){
				this._key_field = this._form.getElement(opts.keyfield_selector);

				if(opts.default_value){
					this._field.set('value', opts.default_value).removeClass('inactive');
				}

				if(!this._field.get('value') || this._field.get('value') == ''){
					this._field.addClass('inactive').set('value', opts.over_text);
				}else{
					this._field.removeClass('inactive');
				}
			}

			if(!opts._results){
				this._results_wrapper = new Element('div', {'class': opts.cls+'_results_wrapper'}).inject(this._field, 'after');
				this._results = new Element('div', {'class': opts.cls+'_results'}).inject(this._results_wrapper);
			}else{
				this._results = opts._results;
			}

			var relay = ':relay('+opts.item_sel+')';
			var evts = {};
			evts['click'+relay] = this.handle_item_click.bind(this);
			evts['mouseenter'+relay] = this.handle_item_mouseover.bind(this);
			evts['mouseleave'+relay] = this.handle_item_mouseout.bind(this);

			this._results.addEvents(evts);

			if(this._results != null){
				this._results.fade('hide');
			}

			if(opts.cache){
				this.cache = [];
			}

			this.attach_textfield_events();
		}

		this.fireEvent('build', [this]);
		return this;
	},

	/**
	attach_textfield_events
	----------
	Add several listeners to the main autocomplete field : keyup, keydown/keypress, blur, focus, click

	###Arguments
	+ _void_

	###Return
	+ _void_
	**/
	attach_textfield_events: function(){
		if(this._field != null){
			this._field.removeEvents().addEvents({
				keyup: this.handle_keyup.bind(this),
				keydown: this.handle_keydown.bind(this),
				blur: this.handle_blur.bind(this),
				focus: this.handle_focus.bind(this),
				click: this.handle_click.bind(this)
			});
		}
	},

	/**
	clear_results
	----------
	Clear the result list

	#Arguments
	+ _void_

	###Return
	+ _this widget_
	**/
	clear_results: function(){
		this._items = [];

		this.current_query_string = null;

		this._results.fade('hide');
		this._results.removeClass('has_results');

		if(this._results.get('html') != ''){
			this._results.empty();
			this.fireEvent('clearResults', [this]);
		}

		return this;
	},

	/**
	create_list
	----------
	Create an element to hold results items. This function won't be call if options.create_list_callback is defined.

	###Arguments
	+ _void_

	###Return
	+ _The list element to be inject to the this._result container_
	**/
	create_list: function(){
		return new Element('ul', {'class': 'items'});
	},

	/**
	create_list
	----------
	Create an element to hold results items. This function won't be call if options.create_list_callback is defined.

	###Arguments
	+ _item_: The result item Object
	+ _query_: The current query string

	###Return
	+ _The list item element to be inject to the list container_
	**/
	create_list_item: function(item, query){
		var opts = this.options,
				key = item[opts.item_key_field] || '',
				value = item[opts.item_value_field] || '',
				url = item[opts.item_url_field] || '#',
				label = value;

		if(query != null && this.options.highlight_markup != null){
			label = label.replace(new RegExp("("+query+")", "gi"), this.options.highlight_markup.substitute({'query':'$1'}));
		}
		var _item = new Element('li', {'class': 'item', 'html':'<a class="item_value" href="'+url+'">'+label+'</a>'});
		if(key != ''){
			_item.set('data-'+opts.item_key_field, key);
		}
		if(value != ''){
			_item.set('data-'+opts.item_value_field, value);
		}
		if(url != '' && url != '#'){
			_item.set('data-'+opts.item_url_field, url);
		}
		return _item;
	},

	/**
	do_query
	----------
	Call the rpc (if no options.data_source_callback is defined). The Cache merchandise is implemented here.

	###Arguments
	+ _void_

	###Return
	+ _This widget_
	**/
	do_query: function(){
		var opts = this.options;

		if(opts.no_query){
			this.fireEvent('noQuery');

			return;
		}

		var query_string = this.get_query_string();
		this.current_query_string = this.current_string = query_string;

		if(query_string == opts.over_text || query_string.length == 0){
			this.fireEvent('emptyQuery', [this]);
			return this.clear_results();
		}else if(query_string.length < opts.min_chars){
			return this;
		}

		this.fireEvent('beforeQuery', [this]);

		if(opts.data_source_callback != null){
			var response_text = opts.data_source_callback.apply(null, [query_string]);
			this.fireEvent('requestSuccess', [this, response_text, query_string])
					.fireEvent('afterQuery', [this, response_text, query_string])
					.handle_response(response_text);
		}else{
			if(this.request != null){
				this.request.cancel();
			}

			if(opts.cache && this.cache.length && this.cache[query_string] != null){
				var response_text = this.cache[query_string];
				this.fireEvent('queryCache', [this, response_text, query_string])
						.handle_response(response_text, query_string);
				return this;
			}else{
				var request_options = {
					url: opts.form_action || this._form.get('action'),
					method: opts.form_method || this._form.get('method'),
					data: opts.external_form ? Object.merge(opts.extra_data, {'query': query_string}) : this._form.toQueryString().trim() + '&' + Object.toQueryString(opts.extra_data),
					onRequest: function(){
						this._element.addClass('loading');
						this.fireEvent('requestSent', [this, query_string]);
					}.bind(this),
					onSuccess: function(response_text){
						this._element.removeClass('loading');
						this.fireEvent('requestSuccess', [this, response_text, query_string])
								.fireEvent('afterQuery', [this, response_text, query_string]);
						if(opts.cache){
								this.cache[query_string] = response_text;
						}
						this.handle_response(response_text, query_string);
					}.bind(this),
					onFailure: function(){
						this._element.removeClass('loading');
						this.fireEvent('requestFail', [this, query_string]);
					}.bind(this)
				};

				this.request = opts.request == 'json'? new Request.JSON(request_options) : new Request(request_options);

				this.request.send();
			}
		}

		return this;
	},

	/**
	format_response
	----------
	Because the return rpc can either be: HTML markup; JSON object with 'html' node contains the HTML markup ({'html': '....'}); or a list of items ({'items': []}), we need a way to standardize the returned result

	###Arguments
	+_response_text_: raw return result from rpc.

	###Return
	+ _JSON object (either with 'items' node or 'html' node). See options.html_key and options.list_key_
	**/
	format_response: function(response_text){
		var json_obj = {};
		try{
			 json_obj = JSONMOO.decode(response_text, false);
		}catch(e){
			 //

		}
		if(typeOf(json_obj) != 'object'){
				json_obj = {};
				json_obj[this.options.html_key] = response_text;
		}
		return json_obj;
	},

	/**
	get_query_string
	----------
	Get the current query string in the autocomplete field.

	###Arguments
	+ _void_

	###Return
	+ _The current query string._
	**/
	get_query_string: function(){
		return this._field.get('value').toString() || "";
	},

	 /**
	handle_blur
	----------
	Called with text field onBlur event. Enable overtext if no value is selected.

	###Arguments
	+ _e_ : the event object

	###Return
	+ _void_
	**/
	handle_blur: function(e){
		// check if input value has complete value of 1st item -> if not-> erase the text field
		var opts = this.options;

		if(this._field.get('value').toString().trim() == '') {
			this._field.addClass('inactive').set('value', opts.over_text);

			if(this._key_field != null){
				this._key_field.set('value', '');
			}
		}

		if(this._key_field != null && this._key_field.get('value') == ''){
			this._field.set('value', '');
		}

		this.timer = this.clear_results.delay(300, this);
		this.fireEvent('textfieldBlur', [this]);
	},

	/**
	handle_click
	----------
	Called with text field onClick event. Do query call.

	###Arguments
	+ _e_ : the event object

	###Return
	+ _void_
	**/
	handle_click: function(e){
		this.disable_type_ahead = true;

		if(!this.options.no_query){
			this.do_query().fireEvent('textfieldClick', [this]);
		}
	},

	/**
	handle_enterkey
	----------
	Handle enter key from the text field. Fill the field with selected item or submit the form or go to an url. See option.item_url_field.

	###Arguments
	+ _void_

	###Return
	+ _void_
	**/
	handle_enterkey: function(){
		// select the first "selected" item -> update value/key fields
		var opts = this.options,
				_selected = this._results.getElement('.selected');

		if(_selected){
			this.handle_item_click(null, _selected);
		}else{
			this.handle_item_click(null, this._results.getElement(opts.result_item_selector));
		}

		this.fireEvent('itemSelected', [this, _selected])

		this.clear_results();
	},

	 /**
	handle_focus
	----------
	Handle focus event from the text field. Clear overtext if current query string == overtext

	###Arguments
	+ _void_

	###Return
	+ _void_
	**/
	handle_focus: function(e){
		var opts = this.options,
				query = this.get_query_string();
		if(opts.over_text != null && opts.over_text == query) {
			this._field.removeClass('inactive')
								 .set('value', '');
		}else{
			this._field.removeClass('inactive')
								 .select();
		}

		if(!this.options.no_query){
			if(!this.current_string || (this.current_string && this.current_string != query)){
				this.do_query();
			}
			this.fireEvent('textfieldFocus', [this]);
		}
	},

	/**
	handle_item_click
	----------
	Call when a result item is clicked: update ID field, automplete field and go the the URL if specified. See options.item_url_field, options.item_value_field, options.item_key_field

	###Arguments
	+ _e_ : Event object

	###Return
	+ _void_
	**/
	handle_item_click: function(e, target){
		if(e){
			e.preventDefault();
		}

		var opts = this.options,
			_item = target;
		if(_item){
			var value = _item.get('data-'+opts.item_value_field);
			if(value){
					if(this._field){
						this._field.set('value', value);
					}
					var key = _item.get('data-'+opts.item_key_field);
					if(this._key_field){
						this._key_field.set('value', key);
					}
			}

			this.fireEvent('itemSelected', [this, _item]);
			// go to url
			var url = _item.get('data-'+opts.item_url_field);
			if(url){
				window.location = url;
			}
		}
	},

	/**
	handle_item_mouseover
	----------
	Call when a result item is mouseoverred. Add a css class (.hover) to the result item. See options.item_hover_cls

	###Arguments
	+ _e_ : Event object

	###Return
	+ _void_
	**/
	handle_item_mouseover: function(e){
		if(e && e.target != null){
			this.fireEvent('itemMouseOver', [this, $(e.target).addClass(this.options.item_hover_cls)]);
		}
	},

	/**
	handle_item_mouseout
	----------
	Call when a result item is mouseoutted. Remove a css class (.hover) to the result item. See options.item_hover_cls

	###Arguments
	+ _e_ : Event object

	###Return
	+ _void_
	**/
	handle_item_mouseout: function(e){
		if(e && e.target != null){
			this.fireEvent('itemMouseOut', [this, $(e.target).removeClass(this.options.item_hover_cls)]);
		}
	},

	/**
	handle_keydown
	----------
	Call when a key is pressed. Ignore some special keys and take special care to some ohter keys.

	###Arguments
	+ _e_ : Event object

	###Return
	+ _void_
	**/
	handle_keydown: function(e){
		 clearTimeout(this.timer);
		 if (e && e.key) {
			 switch (e.key) {
				 case 'enter':
					if(!this.options.submit_onenter){
						this.handle_enterkey();
					}
					// todo: give the ID (the KEY) value back to the input field and submit the form
					this.fireEvent('textfieldKeyDownEnter', [this]);
					return (this.options.submit_onenter && this.get_query_string().length >= this.options.min_chars);
					break;
				 case 'up': case 'down':
					this.navigate(e.key);
					this.fireEvent('textfieldKey'+e.key, [this]);
					return false;
					break;

				 case 'left': case 'right':
					// do nothing
					this.fireEvent('textfieldKey'+e.key, [this]);
					break;
			 }
		 }
		 this.fireEvent('textfieldKeydown', [this, e.key]);

		 return true;
	},

	/**
	handle_keyup
	----------
	Call when a key is pressed and released. Ignore some special keys and take special care to some other keys.

	###Arguments
	+ _e_ : Event object

	###Return
	+ _void_
	**/
	handle_keyup: function(e){
		 if (e && e.key) {
			 switch (e.key) {
				 case 'enter':
						// select 1
						return false;
						break;
				 case 'esc': case 'tab':
					this.clear_results().fireEvent('textfieldKey'+e.key, [this]);
					break;
				 case 'up': case 'down':
					return false;
				 case 'left': case 'right':
					return true;
				 default:
						if(this._key_field){
							this._key_field.set('value', '');
						}
						var query_string = this.get_query_string();
						if(query_string && query_string.length < this.options.min_chars){
							this.clear_results();
						}else{
							this.disable_type_ahead = (e.key == 'backspace' || e.control || e.meta || e.alt);
							if(this.timer) clearTimeout(this.timer);
							this.timer = this.do_query.delay(this.options.delay, this);
						}

			 }
			 this.fireEvent('textfieldKeyup', [this, e.key]);
		 }
		 return true;
	},

	/**
	handle_response
	----------
	Render the respond to the this._result container. Add events to the results items after rendered.

	###Arguments
	+ _response_text_ : the result from rpc
	+ _query_string_ : current query string

	###Return
	+ _this widget_
	**/
	handle_response: function(response_text, query_string){
		var opts = this.options;
		this.clear_results();
		this.current_query_string = query_string;
		var json_obj = this.format_response(response_text);

		if(json_obj[opts.html_key] != null){
			var html = json_obj[opts.html_key];

			if(query_string != null && opts.highlight_markup != null){
				html = html.replace(new RegExp("(?![^<>]*>)("+query_string.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&")+")", "gi"), this.options.highlight_markup.substitute({'query':'$1'}));
			}

			this._results.set('html', html);

			if(opts.result_item_selector != null){
				this._items = this._results.getElements(opts.result_item_selector);
			}
		}else if(json_obj[opts.list_key] != null){
			var _list = (opts.create_list_callback || this.create_list).apply(this);
			json_obj[opts.list_key].each(function(item, idx){
				if(opts.max_results != null && idx < opts.max_results){
					this._items.include(
						(opts.create_list_item_callback || this.create_list_item).apply(this, [item, query_string])
						.set('data-index', idx)
						.inject(_list)
					);
				}
			}.bind(this));

			this._results.grab(_list.set('data-count', json_obj[opts.list_key].length));
		}else{
			// Unknown response
			return;
		}

		if(this._items.length > 0 || json_obj[opts.html_key] != null){
			this._results.addClass('has_results');

			if(opts.type_ahead && !this.disable_type_ahead){
				this.handle_type_ahead();
			}

			if(opts.select_first){
				this.navigate('down');
			}

			this._results.fade('show');
		}

		this.fireEvent('handleResponse', [this, this._results]);
		return this;
	},

	/**
	handle_type_ahead
	----------
	Type ahead functionality.

	###Arguments
	+ _item_ : the result item whose value is used for type ahead.

	###Return
	+ _void_
	**/
	handle_type_ahead: function(_item){
		var sel_end = this._field.selectionEnd;
		var cur_query = this.current_query_string;
		var _items = this._items;

		if(_items.length > 0 && !_item) {
			_item = _items[0];
		}

		if(cur_query != null && _item != null){
			var match_value = _item.get('data-'+this.options.item_value_field);

			if(match_value){
				if(match_value.toUpperCase().indexOf(cur_query.toUpperCase()) === 0){
					if(sel_end == match_value.length){
						return;	// already selected
					}

					this._field.set('value', cur_query + match_value.substring(cur_query.length, match_value.length))
							.selectRange(cur_query.length, match_value.length);
				}else{
					this._field.set('value', cur_query);
				}
			}
		}
	},

	/**
	navigate
	----------
	Hanlde up/down key pressed (select item in the result list)

	###Arguments
	+ _direction_ : (string): up or down

	###Return
	+ _void_
	**/
	navigate: function(direction){
		var cls = 'selected';

		var _selecteds = this._items.filter(function(item, index){
			var is_selected = item.hasClass(cls);

			item.removeClass(cls);

			return is_selected;
		});

		var index = -1;

		if(_selecteds.length > 0){
			index = this._items.indexOf(_selecteds[0]);
		}

		index = (direction == 'up') ? index-1 : (direction == 'down' ?	index+1 : index);
		index = index < 0 ? this._items.length - 1 : ( index > this._items.length - 1 ? 0 : index );

		this._selected_item = this._items[index];

		if(this._selected_item){
			this._selected_item.addClass(cls);

			if(this.options.type_ahead && !this.disable_type_ahead){
				this.handle_type_ahead(this._selected_item);
			}
		}
	}
});
